(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-drop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-drop-countdown')) {
    class HeroDropCountdown extends HTMLElement {
      // Morocco alternates between UTC+1 and UTC+0 (paused DST during Ramadan), so the
      // offset can't be hardcoded -- Intl with the IANA zone resolves it correctly either way.
      static TIME_ZONE = 'Africa/Casablanca';

      static zonedTimeToUtcMs(y, m, d, hh, mm, ss) {
        const wallAsUtc = Date.UTC(y, m - 1, d, hh, mm, ss);
        let guess = wallAsUtc;
        for (let i = 0; i < 2; i++) {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: HeroDropCountdown.TIME_ZONE,
            hour12: false,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
          }).formatToParts(new Date(guess));
          const map = {};
          parts.forEach((p) => { map[p.type] = p.value; });
          const hour = map.hour === '24' ? 0 : Number(map.hour);
          const asUtc = Date.UTC(Number(map.year), Number(map.month) - 1, Number(map.day), hour, Number(map.minute), Number(map.second));
          guess = wallAsUtc - (asUtc - guess);
        }
        return guess;
      }

      static nextSaturday6pmCasablanca() {
        const now = new Date();
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: HeroDropCountdown.TIME_ZONE,
          year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short',
        }).formatToParts(now);
        const map = {};
        parts.forEach((p) => { map[p.type] = p.value; });
        const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const todayIndex = weekdays.indexOf(map.weekday);
        const daysUntilSaturday = (6 - todayIndex + 7) % 7;

        const base = new Date(Date.UTC(Number(map.year), Number(map.month) - 1, Number(map.day)));
        base.setUTCDate(base.getUTCDate() + daysUntilSaturday);

        let targetMs = HeroDropCountdown.zonedTimeToUtcMs(base.getUTCFullYear(), base.getUTCMonth() + 1, base.getUTCDate(), 18, 0, 0);

        if (targetMs <= now.getTime()) {
          targetMs = HeroDropCountdown.zonedTimeToUtcMs(base.getUTCFullYear(), base.getUTCMonth() + 1, base.getUTCDate() + 7, 18, 0, 0);
        }

        return targetMs;
      }

      connectedCallback() {
        this.targetTime = HeroDropCountdown.nextSaturday6pmCasablanca();

        this.dayEl = this.querySelector('[data-unit="d"]');
        this.hourEl = this.querySelector('[data-unit="h"]');
        this.minEl = this.querySelector('[data-unit="m"]');
        this.secEl = this.querySelector('[data-unit="s"]');

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const diff = Math.max(this.targetTime - Date.now(), 0);
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);

        this.dayEl.textContent = String(d).padStart(2, '0');
        this.hourEl.textContent = String(h).padStart(2, '0');
        this.minEl.textContent = String(m).padStart(2, '0');
        this.secEl.textContent = String(s).padStart(2, '0');

        if (diff === 0) clearInterval(this.interval);
      }
    }

    customElements.define('hero-drop-countdown', HeroDropCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
